<template>
	<div>
		<nav-bar />
		<div class="body">
			<video ref="player" class="video-js video" playsinline></video>
		</div>
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
export default {
	components: {
		NavBar
	},
	data() {
		return {
			url: '',
			player: null
		};
	},
	mounted() {
		this.closeShare();
		if (this.$route.query?.type == 1) {
			this.$dataStatistics({ event_type: 'view', page_title: '视频中心-观看视频' }, ``);
		} else {
			this.$dataStatistics({ event_type: 'view', page_title: '产品中心-观看视频' }, ``);
		}
		this.url = decodeURIComponent(this.$route.query.video);

		this.initPlayer();
	},
	methods: {
		initPlayer() {
			this.player = videojs(this.$refs.player, {
				sources: [
					{
						src: this.url,
						type: 'video/mp4'
					}
				],
				controlBar: {
					minHeight: 80 // 设置控制栏的最小高度为60像素
				},
				muted: false,
				autoplay: true,
				controls: true,
				iOS: false, // 禁用iOS自动全屏
				preload: 'auto'
			});
		}
	},
	beforeDestroy() {
		if (this.player) {
			this.player.dispose();
		}
	}
};
</script>
<style lang="less" scoped>
.body {
	height: calc(100vh - 110px);
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #000;

	.video {
		width: 100vw;
		height: 90%;
		display: block;
	}

	/deep/.video-js,
	.video-js {
		& .vjs-control-bar {
			height: 60px !important;
			display: flex;
			align-items: center;
			& > * {
				height: 100%;
				display: flex;
				align-items: center;
				margin: 0 6px;
				span {
					height: 100%;
					display: flex;
					align-items: center;
					font-size: 26px !important; /* 设置控件按钮字体大小为28像素 */

					&::before {
					}
				}
			}

			.vjs-time-control {
				margin: 0 !important;
			}
		}

		/* 控件按钮样式 */
		& .vjs-control-bar .vjs-icon-placeholder,
		& .vjs-control-bar .vjs-icon-placeholder:before,
		& .vjs-control-bar .vjs-icon-placeholder:after,
		& .vjs-control-bar .vjs-icon-placeholder.vjs-icon-volume-mute:before,
		& .vjs-control-bar .vjs-button .vjs-icon-placeholder,
		& .vjs-control-bar .vjs-button .vjs-icon-placeholder:before,
		& .vjs-control-bar .vjs-button .vjs-icon-placeholder:after {
			font-size: 38px; /* 设置控件按钮字体大小为28像素 */
		}

		& .vjs-volume-panel .vjs-volume-control {
			margin-left: 6px;
			opacity: 1;
		}

		& .vjs-volume-panel-horizontal {
			width: 10em;
		}

		& .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
			width: 5em;
			height: 3em;
			transition: visibility 1s, opacity 1s, height 0s 0s, width 1s, left 0s 0s, top 0s 0s;
		}

		& .vjs-seek-to-live-control {
			display: none !important;
		}

		& .vjs-remaining-time {
			display: none !important;
		}

		& .vjs-picture-in-picture-control {
			display: none !important;
		}

		& .vjs-fullscreen-control {
			min-width: 50px;
			margin-right: 20px;
			span.vjs-icon-placeholder {
				flex: 1;
				position: relative;
				line-height: 1;
				&::before {
					display: block;
					top: 50%;
					transform: translateY(-50%);
					width: auto;
					height: auto;
					line-height: 1;
					font-size: 50px !important;
				}
			}
		}

		& .vjs-progress-control {
		}
	}
}
</style>
